import s from './style.module.scss';
import Arrow from '../Arrow/Arrow';
import { Display } from '@/components/Display/Display';
import Mask from '../../../components/Mask';
import cryImg from '@/assets/images/simulation/cry.gif';
import ribbonImg from '@/assets/images/simulation/ribbon.gif';
import cheerImg from '@/assets/images/simulation/cheer.gif';
import FireWork from '../../../components/FireWork';
import { useRef } from 'react';
import { feedBackTypeMap } from '@/utils/contants/caseSimulation';
const FeedBackModal = (props) => {
    const feedbackData = props.resultData;
    const fireWorkRef = useRef(null);
    const { onNext, onReChose, show } = props;

    return (
        <>
            {/* '🥹'🐷 */}
            <Mask show={show} text={feedbackData.is_correct ? '🎉' : '🥹'}>
                <div className={s['feedback-modal-box']}>
                    <div className={s['feedback-modal-content-box']}>
                        <Display show={!feedbackData.is_correct}>
                            <div className={s['feedback-modal-img']}>
                                <img className={s['error']} src={cryImg} alt="" />
                            </div>
                        </Display>
                        <Display show={feedbackData.is_correct}>
                            <div className={s['feedback-modal-img']}>
                                <img className={s['cheer']} src={cheerImg} alt="" />
                                <div className={s['ribbon']}>
                                    <FireWork ref={fireWorkRef}></FireWork>
                                </div>
                                {/* <img className={s['ribbon']} src={ribbonImg} alt="" /> */}
                            </div>
                            <Arrow onClick={onNext} className={s['arrow']} />
                        </Display>
                        <Display show={!feedbackData.is_correct && feedbackData?.feedback_mode !== feedBackTypeMap.instantBackAndCorrect}>
                            <Arrow onClick={onNext} className={s['arrow']} />
                        </Display>
                        <div className={s['feedback-modal-content-container']}>
                            <div className={s['feedback-modal-content']}>{feedbackData.feedback_text}</div>
                            <Display show={!feedbackData.is_correct && feedbackData?.feedback_mode === feedBackTypeMap.instantBackAndCorrect}>
                                <div className={s['feedback-modal-button']} onClick={onReChose}>
                                    重新选择
                                </div>
                            </Display>
                        </div>
                    </div>
                </div>
            </Mask>
        </>
    );
};

export default FeedBackModal;
